import { FormError } from '../types';
import { normalizeTrackingValue } from '../utils';
import { substituteFormName } from './form-interaction';

export const createFormErrorEvent = (args: {
  formName: string;
  message: string | string[];
}): FormError => {
  let { formName, message } = args;

  if (!Array.isArray(message)) {
    message = [message];
  }

  return {
    event_name: 'form-error',
    form_name: substituteFormName(formName),
    error_displayed_message: message
      .map(message => normalizeTrackingValue(message))
      .join(';'),
  };
};

export const createFormErrorEventFromFieldErrors = (args: {
  formName: string;
  errors: Record<string, string | undefined> | undefined;
}) => {
  if (typeof args.errors === 'undefined') {
    return undefined;
  }

  let messages = Object.values(args.errors).filter(
    (message): message is string => typeof message === 'string',
  );

  if (messages.length === 0) {
    return undefined;
  }

  return createFormErrorEvent({
    formName: args.formName,
    message: messages,
  });
};
